import React from "react";
import Peer from 'simple-peer';



class PeerHelper extends React.Component {

    static peer = null;
    static peerID = "";

    static initPeer = ({ isInitiator = false, stream, onSignal = (peerid) => { }, onClose = () => { }, onError = (err) => { }, onConnect = () => { }, onData = () => { }, onStream = () => { } }) => {
        PeerHelper.peer = new Peer({
            initiator: isInitiator,
            trickle: false,
            stream: stream
        })

        // console.log("create peer " + JSON.stringify(peer))
        PeerHelper.peer.on('signal', data => {
            // console.log("on signal" + JSON.stringify(data))
            // console.log("on signal");
            PeerHelper.peerID = JSON.stringify(data);
            onSignal(PeerHelper.peerID)
        })

        PeerHelper.peer.on('close', () => {
            PeerHelper.peer = null;
            onClose();
        })
        PeerHelper.peer.on('error', err => onError(err))
        PeerHelper.peer.on('connect', () => {
            // debug('Connected to peer', peerId)
            // console.log("on connect")
            // PeerHelper.peer.connected = true
            onConnect();
            // this.setPeerState(peerId, peer)
            // peer.send(this.serialize({
            //   msg: 'hey man!'
            // }))
        })

        PeerHelper.peer.on('data', data => {
            onData(data)
        })
        PeerHelper.peer.on('stream', streamData => {
            // console.log("streamData " + streamData)
            onStream(streamData)
        })
    }

    static connectToID = (otherPeerID) => {
        if (!PeerHelper.peer) {
            // console.log("Peer not initiated")
            return;
        }

        PeerHelper.peer.signal(JSON.parse(otherPeerID))
    }
}

export default PeerHelper;